import { useQuery } from '@apollo/client';
import {
  RESOURCE_ALLOCATIONS_QUERY,
  RESOURCE_ALLOCATIONS_QUERY_V2
} from '~/modules/resourcing/common/fragments';
import { ResourceCostModeType } from '~/types';

const useProjectResourceAllocationsByIds = ({
  allocationIds,
  resourceCostMode,
  skip = false,
  useResourceAllocationsV2Query = false
}) => {
  const query = useResourceAllocationsV2Query
    ? RESOURCE_ALLOCATIONS_QUERY_V2
    : RESOURCE_ALLOCATIONS_QUERY;
  const { loading, data } = useQuery(query, {
    variables: {
      filter: {
        resourceAllocationIds: allocationIds
      },
      includeRoleCurrentRate:
        ResourceCostModeType.Rolecost === resourceCostMode,
      includeUserPermittedActions: false,
      includeUserRoles: false
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    skip
  });

  return {
    loadingAllocations: loading,
    resourceAllocations: data?.resourceAllocations?.resourceAllocations || []
  };
};

export default useProjectResourceAllocationsByIds;
